"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageIndexReducerDynamic = exports.pageIndexReducerDynamicInitialState = exports.pageIndexReducerGenerator = void 0;
var utils_1 = require("../../../../utils");
var pageIndexReducerGenerator = function (numPages) {
    var clampFn = (0, utils_1.clamp)(0, numPages - 1);
    return function (state, newValue) {
        switch (newValue.action) {
            case 'input':
                return newValue.index;
            case 'change':
                switch (newValue.op) {
                    case 'first':
                        return 0;
                    case 'prev':
                        return clampFn(state - 1);
                    case 'next':
                        return clampFn(state + 1);
                    case 'last':
                        return clampFn(numPages - 1);
                    default:
                        return state;
                }
        }
    };
};
exports.pageIndexReducerGenerator = pageIndexReducerGenerator;
exports.pageIndexReducerDynamicInitialState = {
    currentPage: 0,
    pageLength: 1
};
var pageIndexReducerDynamic = function (state, action) {
    var currentPage = state.currentPage, pageLength = state.pageLength;
    switch (action.op) {
        case 'page-length':
            return {
                currentPage: currentPage,
                pageLength: Math.max(1, action.pageLength)
            };
        case 'input':
            return {
                currentPage: action.index,
                pageLength: pageLength
            };
        case 'change':
            switch (action.to) {
                case 'first':
                    return {
                        currentPage: 0,
                        pageLength: pageLength
                    };
                case 'prev':
                    return {
                        currentPage: Math.max(0, currentPage - 1),
                        pageLength: pageLength
                    };
                case 'next':
                    return {
                        currentPage: Math.min(pageLength - 1, currentPage + 1),
                        pageLength: pageLength
                    };
                case 'last':
                    return {
                        currentPage: pageLength - 1,
                        pageLength: pageLength
                    };
                default:
                    return state;
            }
    }
};
exports.pageIndexReducerDynamic = pageIndexReducerDynamic;
